module.exports = __webpack_public_path__ + "static/media/jishugongyikaifarenyuan.38c01599.png";